import React from 'react';
import classNames from 'classnames';

import css from './Ingress.module.css';

/**
 * Ingress: a lead paragraph or an opening paragraph
 * It's usually between a headline and the article
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {ReactNode} props.children
 * @returns {JSX.Element} ingress (using 'p' element)
 */
export const Ingress = React.forwardRef((props, ref) => {
  const { className, rootClassName, children, ...otherProps } = props;
  const classes = classNames(rootClassName || css.ingress, className);

  const paragraphs =
    typeof children === 'string'
      ? children
          .split(/\n\s*\n/)
          .map(part => part.replace(/\s*\n\s*/g, ' ').trim())
          .filter(Boolean)
      : null;

  if (paragraphs && paragraphs.length > 1) {
    return (
      <>
        {paragraphs.map((part, index) => (
          <p key={index} className={classes} {...(index === 0 ? { ...otherProps, ref } : {})}>
            {part}
          </p>
        ))}
      </>
    );
  }

  return (
    <p className={classes} {...otherProps} ref={ref}>
      {children}
    </p>
  );
});

Ingress.displayName = 'Ingress';
